module.exports = __webpack_public_path__ + "img/investment_5.ac921245.jpg";